module.exports = __webpack_public_path__ + "fonts/ava_male.svg";